import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import {FILL_CHANGED} from "../../constants/event-types";
import {setFillForPath} from "../../AC/set-fill-for-path";
import Mediator from "../../services/Mediator";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import MobileCtx from "../../../../contexts/MobileCtx";
import ColorPicker from "../ColorPicker";
import FillShadowIcon from "../../../../icons/FillShadowIcon";

export class ClipartFill extends Component {
  static propTypes = {
    setFillForPath: PropTypes.func,
    selected: PropTypes.object
  };
  state = {
    isShow: false,
    fill:
      this.props.selected &&
      (Mediator.isPathGroup(this.props.selected) ||
        Mediator.isPath(this.props.selected))
        ? this.props.selected.fill
        : `#000000`
  };
  onFillChanged = (_, target) => {
    this.setStateFromOPahtGroup(target);
  };
  setStateFromOPahtGroup(oPathGroup) {
    const {fill} = oPathGroup;
    this.setState({
      fill
    });
  }
  handleChange = ({hex}) => {
    this.setState({
      fill: hex
    });
    this.props.setFillForPath(hex);
  };
  componentDidMount() {
    Provider.subscribe(FILL_CHANGED, this.onFillChanged);
  }
  componentDidUpdate(prevProps) {
    const {selected: prevSelected} = prevProps;
    const {selected} = this.props;
    if (
      selected &&
      (Mediator.isPathGroup(selected) || Mediator.isPath(selected)) &&
      JSON.stringify(selected) !== JSON.stringify(prevSelected)
    ) {
      this.setStateFromOPahtGroup(selected);
    }
  }
  componentWillUnmount() {
    Provider.unsubscribe(FILL_CHANGED, this.onFillChanged);
  }
  render() {
    const {fill} = this.state;
    const {selected} = this.props;
    return (
      selected &&
      Mediator.isOneColorPath(selected) && (
        <div className="panel-control__item">
          <div className="clipart-control">
            <div className="clipart-control__content">
              <MobileCtx.Consumer>
                {(isMobile) => (
                  <ColorPicker
                    color={fill}
                    onChange={this.handleChange}
                    position={isMobile ? `top-right` : `bottom-right`}
                    withoutTransparent={true}
                  >
                    <div
                      className="clipart-palette"
                      style={{backgroundColor: fill}}
                    >
                      <FillShadowIcon />
                    </div>
                  </ColorPicker>
                )}
              </MobileCtx.Consumer>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default connect(null, {setFillForPath})(withErrorBoundary(ClipartFill));
